<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright" id="ch00_fm04_dedi"><a id="page_v"></a><em>For my grandchildren:<br/>Davia, Noah, Isabel, and Ruby</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_dedi.vue?6f7f23aa